export default "__VITE_ASSET__Cu6PDBQ7__"